// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"livestream-event-Support__wrapper--2duYu"};